export enum DevicePlatformId {
    UNKNOWN = 0,
    DESKTOP = 1,
    TABLET = 2,
    PHONE = 4,
}
